import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Footer = () => {
  const location = useLocation();
  const isSurityCarePage = location.pathname === '/surity-care';
  return (
    <footer>
      <div className={`footer ${isSurityCarePage ? 'border-top-0' : ''}`}>
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-md-8">
              <div className="footer-left wow fadeInLeft">
                <Link to="/" className="main-logo" aria-label="Surity Select home">
                  <img
                    className="main-logo-img"
                    src="https://imgcdn.kuick.com/surity-select/main-logo-2-white.png"
                    alt="Surity Select — Simple Choices. Sure Decisions."
                    width="159"
                    height="40"
                    loading="lazy"
                  />
                </Link>
                <p className="first">Simple Choices. Sure Decisions.</p>
                <p>
                  Surity Select reviews policies from several companies and products, selecting
                  those that are easy to understand and financially sensible.{' '}
                  <Link to="/surity-story" className="more-link">
                    MORE&gt;
                  </Link>
                </p>
                <div className="d-none d-md-block">
                  <nav aria-label="Legal navigation">
                    <ul className="footer-ul">
                      <li className="single-footer-menu wow fadeInLeft">
                        <Link to="/privacy-statement">Privacy Statement</Link>
                      </li>
                      <li className="single-footer-menu wow fadeInLeft">
                        <Link to="/terms-and-conditions">Terms and Conditions</Link>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>

            {/* desktop only */}
            <div className="col-lg-2 col-md-2 col-6 d-none d-md-block">
              <nav aria-label="Company navigation">
                <ul className="footer-menu-wrapper">
                  <li className="single-footer-menu wow fadeInLeft" data-wow-delay="0.1s">
                    <Link to="/customer-service">Customer Service</Link>
                  </li>
                  <li className="single-footer-menu wow fadeInLeft" data-wow-delay="0.2s">
                    <Link to="/resources">Resources</Link>
                  </li>
                  <li className="single-footer-menu wow fadeInLeft" data-wow-delay="0.3s">
                    <Link to="/careers">Careers</Link>
                  </li>
                  <li className="single-footer-menu wow fadeInLeft" data-wow-delay="0.4s">
                    <Link to="/employers">Employers</Link>
                  </li>
                  <li className="single-footer-menu wow fadeInLeft" data-wow-delay="0.5s">
                    <Link to="/join-agents">Agents</Link>
                  </li>
                </ul>
              </nav>
            </div>

            {/* mobile only */}
            <div className="wow fadeInLeft col-lg-2 col-md-2 col-6 d-block d-md-none">
              <nav aria-label="Site navigation">
                <ul className="footer-menu-wrapper">
                  <li className="single-footer-menu">
                    <Link to="/customer-service">Customer Service</Link>
                  </li>
                  <li className="single-footer-menu">
                    <Link to="/resources">Resources</Link>
                  </li>
                  <li className="single-footer-menu">
                    <Link to="/careers">Careers</Link>
                  </li>
                  <li className="single-footer-menu">
                    <Link to="/employers">Employers</Link>
                  </li>
                  <li className="single-footer-menu">
                    <Link to="/join-agents">Agents</Link>
                  </li>
                  <li className="single-footer-menu">
                    <Link to="/surity-story">Surity Story</Link>
                  </li>
                  <li className="single-footer-menu">
                    <Link to="/membership">Membership</Link>
                  </li>
                  <li className="single-footer-menu">
                    <Link to="/privacy-statement">Privacy Statement</Link>
                  </li>
                  <li className="single-footer-menu">
                    <Link to="/terms-and-conditions">Terms and Conditions</Link>
                  </li>
                </ul>
              </nav>
            </div>

            {/* desktop only — secondary links */}
            <div className="col-lg-2 col-md-2 col-6 d-none d-md-block">
              <nav aria-label="About navigation">
                <ul className="footer-menu-wrapper fmw">
                  <li className="single-footer-menu wow fadeInLeft" data-wow-delay="0.6s">
                    <Link to="/surity-story">Surity Story</Link>
                  </li>
                  <li className="single-footer-menu wow fadeInLeft" data-wow-delay="0.7s">
                    <Link to="/membership">Membership</Link>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
